import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truthy',
  standalone: true
})
export class TruthyPipe implements PipeTransform {

  transform<T>(arr: T[]): T[] {
    return arr.filter(it => !!it);
  }

}
